"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const failedParseObject_1 = require("../helpers/failedParseObject");
const successfulParse_1 = require("../helpers/successfulParse");
const missingValueError_1 = require("../helpers/missingValueError");
exports.parseObject = (value, key) => {
    if (value === null || value === undefined) {
        return missingValueError_1.missingValueError(key);
    }
    if (typeof value !== "object") {
        return failedParseObject_1.failedParseObject(key);
    }
    return successfulParse_1.successfulParse(value);
};
exports.parseOptionalObject = (value, key) => {
    if (value === null || value === undefined) {
        return successfulParse_1.successfulParse(undefined);
    }
    return exports.parseObject(value, key);
};
//# sourceMappingURL=parseObject.js.map